module.exports = __webpack_public_path__ + "f5df1947eb9b84d53e2586f9aa2db9e2.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-52.svg
// module id = 583
// module chunks = 0